/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-56
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_127 from /* 127 */"./127"
var Hf = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, [
    {
      type: "VisibleSwitch"
    }, {
      type: "DisabledSwitch"
    }
  ], {
    type: "BackgroundColor"
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Coordinate"
  }, {
    type: "Size",
    sizeRange: [[Module_127.m, Module_127.k], [Module_127.l, Module_127.j]]
  }, {
    type: "ListViewerStyleTemplate"
  }, {
    type: "ListViewerDataSource"
  }, {
    type: "HelpUrl",
    url: "https://codemao-guide.yuque.com/bfiekm/sbo5kh/list-viewer"
  }
]
export { Hf }
